import React from 'react';

// Tendance optionnelle : direction + libellé court (ex. « +12 % vs mois dernier »).
export type Trend = { direction: 'up' | 'down' | 'flat'; label: string };

const TREND_META: Record<Trend['direction'], { text: string; glyph: string }> = {
  up:   { text: 'text-st-ok',   glyph: '▲' },
  down: { text: 'text-st-bad',  glyph: '▼' },
  flat: { text: 'text-dim',     glyph: '→' },
};

/**
 * Tuile de stat : grosse valeur mono + libellé + tendance optionnelle.
 * Composant pur, style/tokens du design refonte (panel crème, mono uppercase).
 */
const StatTile: React.FC<{
  value: React.ReactNode;
  label: string;
  hint?: string;
  trend?: Trend;
  className?: string;
}> = ({ value, label, hint, trend, className = '' }) => {
  const t = trend ? TREND_META[trend.direction] : null;
  return (
    <div className={`bg-panel border border-line rounded-card p-4 ${className}`}>
      <div className="font-mono text-[9.5px] uppercase tracking-widest text-faint">{label}</div>
      <div className="mt-1 flex items-baseline gap-2">
        <span className="text-[30px] font-bold font-mono leading-none tabular-nums">{value}</span>
        {t && (
          <span className={`font-mono text-[11px] font-semibold ${t.text}`}>
            {t.glyph} {trend!.label}
          </span>
        )}
      </div>
      {hint && <div className="mt-1 text-[11px] text-dim">{hint}</div>}
    </div>
  );
};

export default StatTile;
